module.exports = __webpack_public_path__ + "static/img/Promotin.8a6f5d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Promotin.png
// module id = yas9
// module chunks = 1